import { useEffect } from 'react';
import { useMe } from '@features/user-profile/hooks/useMe';
import { setUserTimeZone } from '@shared/lib/userTz';

/**
 * Headless: keeps the module-level display timezone (`@shared/lib/userTz`) in sync with the
 * profile's `timeZone` (the same IANA id the BE buckets stats with), so EVERY timestamp in the app
 * renders in the USER'S timezone, not the browser's. Mounted once in the AppShell; updates live
 * when the user changes the timezone in Settings (`user.profile.updated` → `['me']` invalidation →
 * this re-runs).
 */
export function UserTimeZoneSync() {
  const me = useMe();
  const tz = me.data?.timeZone;

  useEffect(() => {
    setUserTimeZone(tz ?? null);
  }, [tz]);

  return null;
}
